'use strict'; // Load modules

var Joi = require('../'); // Declare internals


var internals = {};
exports.options = Joi.object({
  abortEarly: Joi.boolean(),
  convert: Joi.boolean(),
  allowUnknown: Joi.boolean(),
  skipFunctions: Joi.boolean(),
  stripUnknown: [Joi.boolean(), Joi.object({
    arrays: Joi.boolean(),
    objects: Joi.boolean()
  }).or('arrays', 'objects')],
  language: Joi.object(),
  presence: Joi.string().only('required', 'optional', 'forbidden', 'ignore'),
  raw: Joi.boolean(),
  context: Joi.object(),
  strip: Joi.boolean(),
  noDefaults: Joi.boolean()
}).strict();